module.exports = __webpack_public_path__ + "static/img/img_mental_barocare.914e782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_mental_barocare.jpg
// module id = gSsY
// module chunks = 0